import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { StihlNotificationDTO } from '../models/stihl-notification-dto';
import { ChangeOrderDTO } from '../models/change-order-dto';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlNotification/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<StihlNotificationDTO> {
    return this.http.get<StihlNotificationDTO>(this.pathAPI + this.controller + id);
  }


  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public changeOrder(data: ChangeOrderDTO[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  }

  public getDataTableOrder(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableOrder', data);
  }

  public getUserAvailableNotification(page: number): Observable<StihlNotificationDTO[]> {
    return this.http.get<StihlNotificationDTO[]>(this.pathAPI + this.controller + "GetUserAvailableNotification/" + page);
  }

  public getUserNotificationCount(): Observable<number> {
    return this.http.get<number>(this.pathAPI + this.controller + 'GetUserNotificationCount/');
  }

  public updateNotificationUser(idNotification: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'UpdateNotificationUser/' + idNotification);
  }


}
